import { useLayoutEffect, useRef } from "react";

export function useEditorLabelWidth() {
  const editorRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const editor = editorRef.current;
    if (!editor) return;

    editor.style.removeProperty("--c1-editor-label-width");
    const labels = Array.from(editor.querySelectorAll<HTMLElement>(".field > .label, .field > label"));
    if (labels.length === 0) return;

    const widestLabel = Math.max(...labels.map((label) => label.scrollWidth));
    editor.style.setProperty("--c1-editor-label-width", `${Math.ceil(widestLabel)}px`);
  });

  return editorRef;
}
